import { GrayColorToken, TGray } from './gray.palette'
import { MonochromeColorToken, TMonochrome } from './monochrome.palette'
import { PrimaryColorToken, TPrimary } from './primary.palette'

export default {
  ...PrimaryColorToken,
  ...GrayColorToken,
  ...MonochromeColorToken,
}

export type TColorV2 = TPrimary | TGray | TMonochrome
